<template>
    <div class="row">
        <div class="col-xl-12 mb-3">
            <h6 class="text-center mb-4"><i class="fa fa-search mr-1"></i> Search User</h6>
        </div>
        <div class="col-xl-4 col-lg-12">
            <div class="card">
                <div class="card-body">
                    <h6>Enter User Email</h6>
                    <p v-if="error" class="text-danger">{{ error }}</p>
                    <users-form :loading="loading" @submit="onSubmit"></users-form>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <h6>Enter User Id</h6>
                    <p v-if="idSearchError" class="text-danger">{{ idSearchError }}</p>
                    <users-id-form :loading="loading" @submit="onSubmitId"></users-id-form>
                </div>
            </div>
        </div>
        <div class="col-xl-8 col-lg-12">
            <div class="card">
                <div class="card-body">
                    <pagination-table
                        :data="userHistory"
                        :propsToSearch="['id', USERS.fields.email]"
                        searchPlaceholder="Search id, email"
                        title="Search User History"
                    >
                        <template slot="table" slot-scope="scope">
                            <user-history-table :data="scope.data"></user-history-table>
                        </template>
                    </pagination-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { USERS } from 'db'
import PaginationTable from 'Shared/Tables/PaginationTable'
import UserHistoryTable from 'Shared/Tables/UserHistoryTable'
import UsersForm from 'Shared/Forms/UsersForm'
import UsersIdForm from 'Shared/Forms/UsersIdForm'
export default {
    components: {
        UsersForm,
        UserHistoryTable,
        PaginationTable,
        UsersIdForm
    },
    data() {
        return {
            USERS,
            loading: false,
            error: false,
            idSearchError: false
        }
    },
    computed: {
        userHistory() {
            const userHistory = this.$store.getters['users/GET_USER_HISTORY']
            return Object.keys(userHistory).map((userId) => ({
                id: userId,
                ...userHistory[userId]
            }))
        }
    },
    methods: {
        async onSubmit(values) {
            this.loading = true
            try {
                const results = await this.$store.dispatch('users/SEARCH_USER_BY_EMAIL', {
                    email: values.email
                })
                if (!results || results.length < 0) this.error = 'No user with email id was found'
                if (results.length > 0) {
                    const user = results[0]
                    this.$store.commit('users/APPEND_USER_HISTORY', {
                        id: user.id,
                        ...user,
                        searchTimestamp: Date.now()
                    })
                    this.$router.push({ name: 'user', params: { id: user.id } })
                    localStorage.setItem(
                        'verdaSupportLastUser',
                        JSON.stringify({
                            id: user.id,
                            email: user[USERS.fields.email]
                        })
                    )
                }
            } catch (err) {
                this.$notify({
                    icon: 'nc-icon nc-simple-remove',
                    message: err.message,
                    type: 'danger',
                    horizontalAlign: 'center',
                    verticalAlign: 'bottom',
                    timeout: 0
                })
            } finally {
                this.loading = false
            }
        },
        async onSubmitId(values) {
            this.loading = true
            try {
                const user = await this.$store.dispatch('users/SEARCH_USER_BY_ID', {
                    id: values.id
                })
                if (!user) {
                    this.idSearchError = 'No user with id was found'
                    return
                }
                user.id = values.id
                this.$store.commit('users/APPEND_USER_HISTORY', {
                    id: user.id,
                    ...user,
                    searchTimestamp: Date.now()
                })
                this.$router.push({ name: 'user', params: { id: user.id } })
                localStorage.setItem(
                    'verdaSupportLastUser',
                    JSON.stringify({
                        id: user.id,
                        email: user[USERS.fields.email]
                    })
                )
            } catch (err) {
                this.$notify({
                    icon: 'nc-icon nc-simple-remove',
                    message: err.message,
                    type: 'danger',
                    horizontalAlign: 'center',
                    verticalAlign: 'bottom',
                    timeout: 0
                })
            } finally {
                this.loading = false
            }
        }
    }
}
</script>
